import _ from "lodash";
import { findByIdInTreeList, findBy$IdInTreeList, findRootProjects } from "../../utils/tree";
import { changePrioritySynchronously as changePrioritySynchronouslyImported } from "./changePrioritySynchronously";
import { changeSiblingPositionSynchronously as changeSiblingPositionSynchronouslyImported } from "./changeSiblingPositionSynchronously";
import * as idb from '../../functions/databaseService/indexedDB';

export const changeGlobalPriority = (data, orderedChildren) => {
    const updatedState = _.cloneDeep(data);
    const project = findBy$IdInTreeList(updatedState, orderedChildren[0].parent.$ref);

    changePrioritySynchronouslyImported(project.children, orderedChildren);

    idb.storeTaskList(updatedState);
    return updatedState;
}

export const changeTodoPriority = (data, taskId, newPriority) => {
    const updatedState = _.cloneDeep(data);
    
    // Only update the moved task's priority - preserve fractional priority system
    const updatedTask = findByIdInTreeList(updatedState, taskId);
    if (updatedTask) {
        updatedTask.globalPriority = newPriority;
    }
    
    return updatedState;
}

export const changeParent = (data, movedTaskId, destinationProjectId, sourceProjectId, destinationIndex) => {
    const updatedState = _.cloneDeep(data);
    const movedTask = findByIdInTreeList(updatedState, movedTaskId);
    let sourceParentProject = null;
    if (sourceProjectId !== "unsorted") {
        sourceParentProject = findBy$IdInTreeList(updatedState, sourceProjectId);
    } else {
        movedTask.parent = { $ref: destinationProjectId };
    }

    const orderedParentProject = findBy$IdInTreeList(updatedState, destinationProjectId);
    const destinationParentProject = findBy$IdInTreeList(updatedState, destinationProjectId);

    if (movedTask && orderedParentProject) {
        if (sourceProjectId !== "unsorted") {
            const movedTaskIndex = sourceParentProject.children.findIndex(task => task.$id === movedTask.$id);
            if (movedTaskIndex !== -1) {
                sourceParentProject.children.splice(movedTaskIndex, 1);
            }
        }
        else {
            const movedTaskIndex = updatedState.findIndex(task => task.$id === movedTask.$id);
            console.log(movedTaskIndex);
            if (movedTaskIndex !== -1) {
                updatedState.splice(movedTaskIndex, 1);
            }
        }
        orderedParentProject.children.splice(destinationIndex, 0, movedTask);

        changePrioritySynchronouslyImported(destinationParentProject.children, orderedParentProject.children);
    }

    idb.storeTaskList(updatedState);

    return updatedState;
}

export const changeSiblingPosition = (data, movedProjectId, newIndex) => {
    const updatedState = _.cloneDeep(data);
    const movedProject = findByIdInTreeList(updatedState, movedProjectId);
    const projects = findRootProjects(updatedState);
    changeSiblingPositionSynchronouslyImported(projects, movedProject, newIndex);
    idb.storeTaskList(updatedState);
    return updatedState;
}

// Optimistic update for reordering children within a parent (Overview page)
export const orderSiblings = (data, parentId, orderedIds) => {
    const updatedState = _.cloneDeep(data);
    
    // Find the parent project
    const parent = parentId ? findByIdInTreeList(updatedState, parentId) : null;
    const children = parent ? parent.children : updatedState;
    
    if (!children || children.length === 0) {
        return updatedState;
    }
    
    // Update siblingOrder for each child based on the new ordered IDs
    orderedIds.forEach((id, index) => {
        const child = children.find(c => c.id === id);
        if (child) {
            child.siblingOrder = index;
        }
    });
    
    return updatedState;
}